// form/stepFields.ts
import type { PreLodgementChecklistFormValues } from '../types/preLodgementChecklist';
import type { PreLodgementChecklistStepKey } from '../types/preLodgementChecklist';

// The order users walk through — index 0 is the first screen they see
export const STEP_ORDER = [
  'personalDetails',
  'propertyIncome',
  'otherIncome',
  'futurePlans',
  'reviewNotes',
] as const satisfies readonly PreLodgementChecklistStepKey[];

// Which form fields belong to each step
export const STEP_FIELDS: Record<
  PreLodgementChecklistStepKey,
  readonly (keyof PreLodgementChecklistFormValues)[]
> = {
  // Step 1 — Personal Details
  personalDetails: ['taxFinancialYear', 'citizenship', 'taxResidencyStatus'],

  // Step 2 — Property Income
  propertyIncome: [
    'propertyDisposalAnswer',
    'propertyDisposalNotes',
    'propertyRefinanceAnswer',
    'propertyRefinanceNotes',
    'propertyPurchaseAnswer',
    'propertyPurchaseNotes',
  ],

  // Step 3 — Other Income
  otherIncome: [
    'incomeSource',
    'employer',
    'annualSalary',
    'annualSalaryCurrency',
    'bonusesAndBenefits',
    'bonusesAndBenefitsCurrency',
    'dividendAnswer',
    'cryptoAnswer',
    'shareDisposalAnswer',
  ],

  // Step 4 — Future Plans
  futurePlans: [
    'planningToBuyAnswer',
    'planningToBuyNotes',
    'propertySaleAnswer',
    'propertySaleNotes',
    'repatriationAnswer',
    'repatriationDate',
  ],

  // Step 5 — Additional Details
  reviewNotes: ['additionalQuestions', 'wantsMortgageReview'],
};

// Look up fields by numeric step index (0-based)
export const fieldsForIndex = (index: number) => {
  const key = STEP_ORDER[index];
  return STEP_FIELDS[key];
};
